import Link from 'next/link';
import type { FC } from 'react';
import type {
	CommonLabelProps,
	SponsorLabelProps,
} from '@/components/raven/ui/Label';

import styles from './styles.module.css';

interface LabelTextContentWrapperProps
	extends Pick<CommonLabelProps, 'text' | 'title'>,
		Pick<SponsorLabelProps, 'sponsorLink'> {}

export const LabelTextContentWrapper: FC<LabelTextContentWrapperProps> = ({
	sponsorLink,
	text,
	title,
}) => {
	if (title && text) {
		return (
			<div className={styles.labelTextContent}>
				<strong>{title}</strong>
				{sponsorLink ? (
					<Link
						className={styles.labelSponsorLink}
						href={sponsorLink}
						rel="noreferrer nofollow"
						target="_blank"
					>
						{text}
					</Link>
				) : (
					text
				)}
			</div>
		);
	}

	return text;
};
